import { ref } from '../config/firebase';

export function getLicenses(companyId) {
    return ref.child(`LICENSES/${companyId}`).once('value')
        .then((LicensesSnapshot) => LicensesSnapshot.exists() && LicensesSnapshot.val() || {});
}

export function createLicense(companyId, license) {
    return ref.child(`LICENSES/${companyId}/${license.id}`).set({ dev: license });
}

export function updateLicense(companyId, license, licenseEnv) {
    return ref.child(`LICENSES/${companyId}/${license.id}/${licenseEnv}`).update(license);
}

export function removeLicense(companyId, licenseId) {
    return ref.child(`LICENSES/${companyId}/${licenseId}`).remove();
}



// WEBPACK FOOTER //
// ./src/firebase/licenses.js